import { decryptedData, getConfigFromStroage } from "../utils/getUrlsFromAws";
import { env } from "./../env/env";

const api = {
  qualTechDevBaseUrl:
    "https://n913i5xkoi.execute-api.ap-south-1.amazonaws.com/Stage/",
  mliDevBaseUrl:
    "https://djedtvaxn2.execute-api.ap-south-1.amazonaws.com/posvdev/",
  baseUrl:
    "https://oqh2u2s6hf.execute-api.ap-south-1.amazonaws.com/posvuat/api/",
  // baseUrl:
  //   "http://posvapi.maxlifeinsurance.com/uat/api/",
  // baseUrl:
  //   "https://djedtvaxn2.execute-api.ap-south-1.amazonaws.com/posvdev/api/",
  // baseUrl:
  //   "https://apiddev.maxlifeinsurance.com/posvdev/api/",
  mliUatBaseUrl:
    "https://oqh2u2s6hf.execute-api.ap-south-1.amazonaws.com/posvuat/",
  mliProdBaseUrl:
    "https://lg0gitgvtb.execute-api.ap-south-1.amazonaws.com/posvprod/",
  routes: {
    verifyUser: {
      qualTechDevUrl: "verify-customer-link",
      mliDevUrl: "validate-customer-link-dev",
      mliUatUrl: "validate-customer-link-uat",
      mliProdUrl: "validate-customer-link-prod",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: { posvRefNumber: "", iosStatus: false },
        },
      },
    },
    saveCookiesDrop: {
      qualTechDevUrl: "save-cookiesdrop",
      mliDevUrl: "save-cookiesdrop-dev",
      mliUatUrl: "save-cookiesdrop-uat",
      mliProdUrl: "save-cookiesdrop-prod",
      ecsEndpoint: "save-cookiesdrop",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: { posvRefNumber: "", posvTokenId: "" },
        },
      },
    },
    verifyCustomerImage: {
      qualTechDevUrl: "verify-customer-image",
      mliDevUrl: "validate-customer-image-dev",
      mliUatUrl: "validate-customer-image-uat",
      mliProdUrl: "validate-customer-image-prod",
      ecsEndpoint: "validate-customer-image",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {
            posvRefNumber: "",
            imageFile: "",
            authToken: "",
            fileExtension: "",
          },
        },
      },
    },
    getOtp: {
      qualTechDevUrl: "getotp",
      mliDevUrl: "get-otp-dev",
      mliUatUrl: "get-otp-uat",
      mliProdUrl: "get-otp-prod",
      body: {
        request: {
          header: { correlationId: "", appId: "ABC" },
          payload: { posvRefNumber: "", authToken: "", onCallOTP: "No" },
        },
      },
    },
    validateOtp: {
      qualTechDevUrl: "validateotp",
      mliDevUrl: "validate-otp-dev",
      mliUatUrl: "validate-otp-uat",
      mliProdUrl: "validate-otp-prod",
      body: {
        request: {
          header: { correlationId: "", appId: "ABC" },
          payload: { posvRefNumber: "", otp: "", authToken: "" },
        },
      },
    },
    declaration: {
      qualTechDevUrl: "customer-disclaimer",
      mliDevUrl: "customer-disclaimer-dev",
      mliUatUrl: "customer-disclaimer-uat",
      mliProdUrl: "customer-disclaimer-prod",
      body: {
        request: {
          header: { correlationId: "", appId: "ABC" },
          payload: { posvRefNumber: "", customerDisclaimer: "", authToken: "" },
        },
      },
    },
    pdf: {
      qualTechDevUrl: "get-pdf-transcript",
      mliDevUrl: "get-pdf-transcript-dev",
      mliUatUrl: "get-pdf-transcript-uat",
      mliProdUrl: "get-pdf-transcript-prod",
      ecsEndpoint: "get-pdf-transcript",
      body: {
        request: {
          header: { correlationId: "", appId: "mpro" },
          payload: { posvRefNumber: "" },
        },
      },
    },

    getQuestions: {
      qualTechDevUrl: "get-questions",
      mliDevUrl: "get-questions-dev",
      mliUatUrl: "get-questions-uat",
      mliProdUrl: "get-questions-prod",
      ecsEndpoint: "get-questions",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {
            qstCatName: "",
            qstSubCatName: null,
            posvRefNumber: "",
            qstCatNameNext: null,
            qstCatNamePrevious: null,
            lang: localStorage.getItem("LanguageSelected"),
            authToken: "",
            planCode: "",
          },
        },
      },
    },
    saveCustomerResponse: {
      qualTechDevUrl: "save-customer-response",
      mliDevUrl: "save-customer-response-dev",
      mliUatUrl: "save-customer-response-uat",
      mliProdUrl: "save-customer-response-prod",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {
            customerResponse: { qst: [] },
            qstCatName: "",
            qstSubCatName: null,
            posvRefNumber: "",
            lang: "EN",
            planCode: "",
            qstCatNameNext: null,
            qstSubCatNameNext: null,
            qstCatNamePrevious: null,
            qstSubCatNamePrevious: null,
            authToken: "",
          },
        },
      },
    },
    wopRider: {
      qualTechDevUrl: "getSingleQuestionMock",
      mliDevUrl: "getSingleQuestionMock",
      mliUatUrl: "getSingleQuestionMock",
      mliProdUrl: "getSingleQuestionMock",
      body: {
        request: {
          header: {
            appId: "foo",
            correlationId: "foo",
          },
          payload: {
            qstCatName: "foo",
            posvRefNumber: "foo",
            LANG: "foo",
            authToken: "foo",
            planCode: "foo",
          },
        },
      },
    },
    validateCustomerSelfie: {
      qualTechDevUrl: "validate-customer-selfie",
      mliDevUrl: "validate-customer-selfie",
      mliUatUrl: "validate-customer-selfie",
      mliProdUrl: "validate-customer-selfie",
      body: {
        request: {
          header: {
            appId: "mpro",
            correlationId: "",
          },
          payload: {
            posvRefNumber: "",
            multipleImageFile: [],
            authToken: "",
            fileExtension: "",
            iosStatus: false,
            planCode: "",
          },
        },
      },
    },

    validateUploadLink: {
      qualTechDevUrl: "axis-tele-sales",
      mliDevUrl: "axis-tele-sales",
      mliUatUrl: "axis-tele-sales",
      mliProdUrl: "axis-tele-sales",
      body: {
        request: {
          header: {
            appId: "mpro",
            correlationId: "SIRZxpsFSB",
          },
          payload: {
            action: "",

            uploadRequestPayload: {},
            submitRequestPayload: {},
          },
        },
      },
    },

    policySearch: {
      qualTechDevUrl: "policy-search",
      mliDevUrl: "resend-customer-link-dev",
      mliUatUrl: "resend-customer-link-uat",
      mliProdUrl: "resend-customer-link-prod",
      body: {
        request: { header: { correlationId: "", appId: "mpro" }, payload: {} },
      },
    },

    customerDeclarationValidlink: {
      qualTechDevUrl: "customerdeclarationvalidlink",
      mliDevUrl: "customerdeclarationvalidlink",
      mliUatUrl: "customerdeclarationvalidlink",
      mliProdUrl: "customerdeclarationvalidlink",
      ecsEndpoint: "customerValidateLink",
      body: {
        request: {
          header: {
            correlationId: "",
            appId: "mpro"
          },
          payload: {
            posvRefNumber: ""
          }
        }

      },
    },

    customerDeclarationGenOtp: {
      qualTechDevUrl: "customerdeclarationgenotp",
      mliDevUrl: "customerdeclarationgenotp",
      mliUatUrl: "customerdeclarationgenotp",
      mliProdUrl: "customerdeclarationgenotp",
      ecsEndpoint: "customerGetOtp",
      body: {
        request: {
          header: {
            correlationId: "",
            appId: "FULFILLMENT"
          },
          payload: {
            posvRefNumber: ""
          }
        }
      }
    },

    customerDeclarationValidOtp: {
      qualTechDevUrl: "customerdeclarationvalidotp",
      mliDevUrl: "customerdeclarationvalidotp",
      mliUatUrl: "customerdeclarationvalidotp",
      mliProdUrl: "customerdeclarationvalidotp",
      ecsEndpoint: "customerValidateOtp",
      body: {
        request: {
          header: {
            correlationId: "",
            appId: "FULFILLMENT"
          },
          payload: {
            posvRefNumber: "",
            otp: ""
          }
        }

      }
    },

    biDetail: {
      ecsEndpoint: "bi-details",
      body: {
        request: {
          header: {
            correlationId: "",
            appId: "FULFILLMENT",
            host: ""
          },
          payload: {
              posvRefNumber: ""
            }
        }
      }
    },
    getDbStatusEndPoint: {
      ecsEndpoint: "get-db-status",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: { declarationids: null, lang: "" },
        },
      },
    },
    getPresignedUrl: {
      ecsEndpoint: "getPresignedUrl",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: { posvRefNumber: "" },
        },
      },
    },
     ifscmicr: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {  },
        },
      },
    },
     pennydropservice: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {  },
        },
      },
    },
     tbcheckstatus: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: { },
        },
      },
    },
     tbpiisave: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {  },
        },
      },
    },
     tbUnifiedPayment: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {  },
        },
      },
    },
    tbUnifiedPaymentStatus: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {  },
        },
      },
    },
    tbPaymentCallback: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {  },
        },
      },
    },
  },
};

const sellerDeclarationApi = {
  qualTechDevBaseUrl: 'https://fd8ocqs3a9.execute-api.ap-south-1.amazonaws.com/stage/',
  mliDevBaseUrl: '',
  mliUatBaseUrl: 'https://oqh2u2s6hf.execute-api.ap-south-1.amazonaws.com/posvuat/',
  mliProdBaseUrl: 'https://lg0gitgvtb.execute-api.ap-south-1.amazonaws.com/posvprod/',
  routes: {
    sellerConsentDetails: {
      qualTechDevUrl: 'seller-consent-details',
      mliDevUrl: 'seller-consent-details',
      mliUatUrl: 'seller-consent-details',
      mliProdUrl: 'seller-consent-details-prod',
      body: { "request": { "header": { "appId": "THANOS", "correlationId": "1234" }, "payload": { "encryptedValue": "8hgfgjdftre243vhg" } } }
    },
    sellerConsentFormData: {
      qualTechDevUrl: 'seller-consent-form-data',
      mliDevUrl: 'seller-consent-form-data',
      mliUatUrl: 'seller-consent-form-data',
      mliProdUrl: 'seller-consent-form-data-prod',
      body: { "request": { "header": { "appId": "THANOS", "correlationId": "" }, "payload": { "identifier": "quoteId", "value": "10", "period": 10, "periodUnit": "year", "sellerDisclosure": true, "questions": [] } } }
    },
    soaValidateOtpApi: {
      ecsEndpoint: "",
      body: {
        request: {
          header: { appId: "mpro", correlationId: "" },
          payload: {},
        },
      },
    },
  }
}

const consentUploadApi = {
  qualTechDevBaseUrl: "https://kf4z3mkrp1.execute-api.ap-south-1.amazonaws.com/dev/",
  mliDevBaseUrl: "https://uxsk78ztg4.execute-api.ap-south-1.amazonaws.com/uat/",
  mliUatBaseUrl: "https://uxsk78ztg4.execute-api.ap-south-1.amazonaws.com/uat/",
  mliProdBaseUrl: "https://lg0gitgvtb.execute-api.ap-south-1.amazonaws.com/posvprod/",
  routes: {
    uploadChunk: {
      qualTechDevUrl: "api/upload-chunk",
      mliDevUrl: "api/upload-chunk",
      mliUatUrl: "api/upload-chunk",
      mliProdUrl: "api/upload-chunk",
      body: {}
    },
    verifyVideo: {
      qualTechDevUrl: "api/verify-video",
      mliDevUrl: "api/verify-video",
      mliUatUrl: "api/verify-video",
      mliProdUrl: "api/verify-video",
      body: {}
    },
    verifyVideoStatus: {
      qualTechDevUrl: "api/verify-video",
      mliDevUrl: "api/verify-video",
      mliUatUrl: "api/verify-video",
      mliProdUrl: "api/verify-video",
      body: {}
    },
    mergeChunk: {
      qualTechDevUrl: "api/merge-chunk",
      mliDevUrl: "api/merge-chunk",
      mliUatUrl: "api/merge-chunk",
      mliProdUrl: "api/merge-chunk",
      body: {
        "flowIdentifier": "",
        "flowFilename": ""
      }
    },
    getToken: {
      qualTechDevUrl: "api/get-token",
      mliDevUrl: "api/get-token",
      mliUatUrl: "api/get-token",
      mliProdUrl: "api/get-token",
      body: {
        "request": {
          "header": {
            "correlationId": "test123",
            "appId": "Test"
          },
          "payload": {
            "clientId": "",
            "clientSecret": ""
          }
        }
      }
    },
  }

}


const getUrl = (route) => {
  let urlsData = getConfigFromStroage();
  const useEcsApi = urlsData["useEcsApi"];
  let useEcsApiEnabled;

  if (useEcsApi) {
    useEcsApiEnabled = decryptedData(useEcsApi) === "Y" && isEcsEnabaledForEndpoint(route)
  }
  const ecsBaseUrl = decryptedData(urlsData[`baseUrlEcs`])

  if (route === 'sellerConsentDetails' || route === 'sellerConsentFormData' || route === "soaValidateOtpApi") {
    // const baseUrl = sellerDeclarationApi[`${env}BaseUrl`];
    // const pathUrl = `${env}Url`;
    // let sellerDeclarationUrl = `${baseUrl}${sellerDeclarationApi["routes"][route][pathUrl]}`;
    const baseUrl = decryptedData(urlsData[`baseUrl`]);
    const pathUrl = decryptedData(`${urlsData[validateECSRoute(route)]}`);
    let sellerDeclarationUrl = useEcsApiEnabled ? `${ecsBaseUrl}${pathUrl}`:`${baseUrl}${pathUrl}`;
    return sellerDeclarationUrl;
  }
  if (route === 'uploadChunk' || route === 'mergeChunk' || route === 'getToken' || route === 'verifyVideo' || route === 'verifyVideoStatus') {
    // const baseUrl = consentUploadApi[`${env}BaseUrl`];
    // const pathUrl = `${env}Url`;
    // let consentUploadUrl = `${baseUrl}${consentUploadApi["routes"][route][pathUrl]}`;
    const baseUrl = decryptedData(urlsData[`videoUploadBaseUrl`]);
    const pathUrl = decryptedData(`${urlsData[validateECSRoute(route)]}`);
    let consentUploadUrl = useEcsApiEnabled ? `${ecsBaseUrl}${pathUrl}`:`${baseUrl}${pathUrl}`;
    return consentUploadUrl;
  }

  // const baseUrl = api[`${env}BaseUrl`];
  // const pathUrl = `${env}Url`;
  // let url = `${baseUrl}${api["routes"][route][pathUrl]}`;
  const baseUrl = decryptedData(urlsData[`baseUrl`]);
  const pathUrl = decryptedData(`${urlsData[validateECSRoute(route)]}`);
  let url = useEcsApiEnabled ? `${ecsBaseUrl}${pathUrl}`:`${baseUrl}${pathUrl}`;
  return url;
};

const getBody = (route) => {
  if (route === 'sellerConsentDetails' || route === 'sellerConsentFormData' || route === 'soaValidateOtpApi') {
    return sellerDeclarationApi["routes"][route]["body"]
  }
  if (route === 'uploadChunk' || route === 'mergeChunk' || route === 'getToken' || route === 'verifyVideo' || route === 'verifyVideoStatus') {
    return consentUploadApi["routes"][route]["body"]
  }

  return api["routes"][route]["body"];
};

export const getApiData = (route) => {
  const url = getUrl(route);
  const body = getBody(route);
  return { url, body };
};

export const validateECSRoute = (route) => {
  const urlsData = getConfigFromStroage();
  const useEcsApi = urlsData["useEcsApi"];
  let newRoute;
  let useEcsApiEnabled;

  if (useEcsApi) {
    useEcsApiEnabled = decryptedData(useEcsApi) === "Y"
  }

  if (useEcsApiEnabled && isEcsEnabaledForEndpoint(route)) {
    newRoute = `${route}EcsUrl`
  } else {
    newRoute = route
  }
  
  return newRoute
}

// const EcsEnabledAPIs = ["getDbStatusEndPoint", "saveCookiesDrop", "pdf", "verifyCustomerImage", "biDetail", "customerDeclarationValidlink", "customerDeclarationGenOtp", "customerDeclarationValidOtp"]
const isEcsEnabaledForEndpoint = (route) => {
  const urlsData = getConfigFromStroage();
  const apisMigratedToEcs = urlsData['apisMigratedToEcs']
  let EcsEnabledAPIs = []
  if(apisMigratedToEcs) {
    EcsEnabledAPIs = decryptedData(apisMigratedToEcs).split(",")
  }
  // console.log({ apisMigratedToEcs, EcsEnabledAPIs })
  return EcsEnabledAPIs.includes(route)
}

export const createEcsApisArr = () => {
  const urlsData = getConfigFromStroage();
  const apisMigratedToEcs = urlsData['apisMigratedToEcs']
  let EcsEnabledAPIs = []
  if(apisMigratedToEcs) {
    EcsEnabledAPIs = decryptedData(apisMigratedToEcs).split(",")
  }
  const arr = []
  console.log({ EcsEnabledAPIs })
  EcsEnabledAPIs.forEach((api)=>{
    const url = getUrl(api)
    arr.push(url)
  })

  return arr
}
